import React, { useState } from 'react';
import Button from '../components/core/Button';
import Wrapper from '../components/core/Wrapper';
import Modal from '../components/Modals/Modal';
import { getFormattedPrice } from '../helpers/price';
import { payPlan } from '../helpers/wompi';
import usePlansData from '../hooks/usePlansData';
import COImg from '../images/co.png';
import CreditCardsImg from '../images/credit-cards.png';
import SecureIconImg from '../images/secure-icon.svg';
import { useGlobalContext } from '../stores/global';
import styles from './Plans.module.css';

const planItems = [
  ['Publicación de la propiedad en hauscanner.com', true],
  ['Agendamiento de citas para que tus clientes conozcan la propiedad', true],
  ['Link para solicitar crédito hipotecario', true],
  ['Pago de separación de la propiedad *', true],
  //['Firma de la promesa de compraventa', true],
  //['Proceso notarial', true],
];

const planHeaders = [
  {
    title: 'Todas las propiedades',
    price: 0,
  },
];

const serviceDescriptions = [
  ['fotografiasPropiedad', 'Fotografías de la propiedad (20 unidades)'],
  ['edicionFotografias', 'Edición de las Fotografías'],
  ['fotografoEspecializado', 'Fotógrafo especializado'],
  [
    'apoyoPublicacion',
    'Apoyo de la publicación del inmueble en hauscanner.com',
  ],
  [
    'entregaMaterialDigitalDerechosAutor',
    'Entrega del material en formato digital y trasmisión de derechos de autor',
  ],
  ['videoTour360', 'Video tour 360° (1 Unidad)'],
  ['edicionVideo', 'Edición de video'],
  [
    'publicacionGratuita',
    'Publicación gratuita de la propiedad en hauscanner.com',
  ],
];

const metadataInfo = (
  <div className={styles.metaContainer}>
    <ul>
      <li>*Estos precios incluyen IVA</li>
      <li>
        <img src={COImg} alt="Secure payments" width="20" height="21" />
        <p>Precios en pesos colombianos</p>
      </li>

      <li>
        <img src={SecureIconImg} alt="Secure payments" width="20" height="21" />
        <p>Compra segura, protegemos tus datos</p>
      </li>
    </ul>

    <p>Multiples medios de pago</p>
    <img src={CreditCardsImg} alt="Payment Methods" width="230" />
  </div>
);

export default function Plans() {
  const { user } = useGlobalContext();
  const [selectedPlan, setSelectedPlan] = useState<any>();
  const { data: plans } = usePlansData();

  return (
    <Wrapper
      subHeader={{ title: 'PLANES' }}
      contentProps={{ className: styles.content }}
    >
      <h1>Planes</h1>
      <p>Se ofrecen los siguientes planes</p>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>{metadataInfo}</th>
            {planHeaders.map((el, idx) => (
              <th key={idx}>
                <div className={styles.headerItem}>
                  <h2>{el.title}</h2>
                  {/* <h3>{getFormattedPrice(el.price)}</h3> */}
                  <small>
                    *cancelas al momento de que se realizar una separación.
                  </small>
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {planItems.map((el, idx) => (
            <tr key={idx}>
              <td>{el[0]}</td>
              <td>
                {el[1] ? <i className="fonticons fonticons-checked" /> : null}
              </td>
              <td>
                {el[2] ? <i className="fonticons fonticons-checked" /> : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className={styles.pricingItems}>
        {planHeaders.map((it, idx) => (
          <div key={idx} className={styles.pricingItem}>
            <h2>{it.title}</h2>
            <div className={styles.pricingContent}>
              <h3>{getFormattedPrice(it.price)}</h3>
              <small>*cancelas al momento de que se realiza la venta.</small>
              <ul>
                {planItems.map((el, idx2) =>
                  el[idx + 1] ? <li key={idx2}>{el[0]}</li> : null
                )}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <span
        id="other-services"
        style={{ marginTop: -80, paddingTop: 80, display: 'block' }}
      />

      <h1>Otros servicios</h1>
      <p>También ofrecemos los siguientes servicios</p>

      {plans && (
        <>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>{metadataInfo}</th>
                {plans.map((el: any, idx: any) => (
                  <th key={idx}>
                    <div className={styles.headerItem}>
                      <h2>{el.name}</h2>
                      <h3>{getFormattedPrice(el.price)}</h3>
                      <button onClick={() => setSelectedPlan(el)}>
                        COMPRAR
                      </button>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {serviceDescriptions.map((el, idx) => (
                <tr key={idx}>
                  <td>{el[1]}</td>
                  {plans.map((el2: any, idx2: any) => (
                    <td key={idx2}>
                      {el2.features.includes(el[0]) ? (
                        <i className="fonticons fonticons-checked" />
                      ) : null}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          <div className={styles.pricingItems}>
            {plans.map((el: any, idx: any) => (
              <div key={idx} className={styles.pricingItem}>
                <h2>{el.name}</h2>
                <div className={styles.pricingContent}>
                  <h3>{getFormattedPrice(el.price)}</h3>
                  <ul>
                    {el.features.map((ft: any, idx2: number) => (
                      <li key={idx2}>
                        {serviceDescriptions.find((el3) => el3[0] === ft)?.[1]}
                      </li>
                    ))}
                  </ul>
                  <button onClick={() => setSelectedPlan(el)}>COMPRAR</button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <div className={styles.hideTabletUp}>{metadataInfo}</div>

      <Modal
        title="COMPRAR"
        open={!!selectedPlan}
        onClose={() => setSelectedPlan(undefined)}
        footer={
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {user && !user.plan?.reference && (
              <Button
                label="ACEPTAR"
                onClick={() => {
                  payPlan({
                    userId: user.id,
                    amountInPesos: selectedPlan.price,
                    planId: selectedPlan.id,
                  });

                  // close modal after showing wompi modal
                  setSelectedPlan(undefined);
                }}
              />
            )}

            {(!user || user.plan?.reference) && (
              <Button
                label="CERRAR"
                onClick={() => setSelectedPlan(undefined)}
              />
            )}
          </div>
        }
      >
        <div>
          {user && !user.plan?.reference && (
            <p>
              Para cuadrar hora lugar y fecha de la toma del servicio, nosotros
              nos comunicaríamos por correo electrónico o celular tan pronto
              hayas realizado el pago
            </p>
          )}

          {user && user.plan?.reference && (
            <p>
              Ya has adquirido el plan{' '}
              <b>
                {plans?.find((el: any) => el.id === user.plan.reference)?.name}
              </b>
            </p>
          )}
          {!user && <p>Debes iniciar sesión antes de comprar</p>}
        </div>
      </Modal>
    </Wrapper>
  );
}
